module.exports = __webpack_public_path__ + "img/slider_contact2.4083824d.jpg";